var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"SqneFkFvGAhc6Uj9DaaC9"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs"

const ENV = process.env.NEXT_PUBLIC_DOMAIN_ENV || "dev"
const isProd = ENV === "prod"

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_DOMAIN_SENTRY_DSN,

  ignoreErrors: [
    "ResizeObserver loop limit exceeded", // Ignore ResizeObserver loop limit exceeded errors
    "Non-Error promise rejection captured", // Ignore unhandled promise rejections that are not Error objects
    "messaging/unsupported-browser" // Ignore Firebase Messaging unsupported browser errors
  ],

  // Tag each event with the current environment (dev / staging / prod)
  environment: ENV,

  // Performance tracing: lower sample rate in production to control volume
  tracesSampleRate: isProd ? 0.2 : 1.0,

  // Session Replay: record sessions and always replay on error
  replaysSessionSampleRate: isProd ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [new Sentry.Replay()],

  // In non-prod, print internal Sentry logs to browser console
  debug: !isProd,

  // Filter out known non-critical errors before sending to Sentry
  beforeSend(event, hint) {
    const err = hint?.originalException
    // Drop AbortErrors (triggered when component unmounts mid-fetch)
    if (err instanceof Error && err.name === "AbortError") return null
    // Drop generic network failures (usually caused by offline users or ad-blockers)
    if (err instanceof TypeError && err.message?.includes("Failed to fetch")) return null
    return event
  }

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
